export const DateHelper = {
  /**
   * Добавляет дни к дате
   */
  addDaysToDate(source: Date | string, days: number): string {
    const dateInMs = Date.parse(source.toString())
    const fullDate = new Date(dateInMs)
    const newDay = fullDate.getDate() + days
    fullDate.setDate(newDay)
    return fullDate.toUTCString()
  },
}

export default DateHelper
